import { create } from 'zustand';

type EmailContext = 'signup' | 'forgot-password';

type State = {
  email?: string;
  emailContext?: EmailContext;
};

type Actions = {
  setEmail: (args: { email: string; context: EmailContext }) => void;
  clearEmail: () => void;
};

type AuthStore = State & Actions;

export const useAuthStore = create<AuthStore>(set => ({
  email: undefined,
  emailContext: undefined,

  setEmail: ({ email, context }) => set({ email, emailContext: context }),

  clearEmail: () => set({ email: undefined, emailContext: undefined })
}));
